import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import classNames from "classnames";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

export interface SeparatorWithTextProps {
   text: string;
}
export const SeparatorWithText: React.FC<SeparatorWithTextProps> = ({ text }) => {
   return (
      <div className="separator-wt">
         <div className="separator-wt-text">{text}</div>
      </div>
   )
}